// extracted by mini-css-extract-plugin
export var background = "_64-0";
export var buttonPrimary = "_64-1";
export var container = "_64-2";
export var containerTopLayerApi = "_64-3";
export var feature = "_64-6";
export var featureBody = "_64-7";
export var featureIcon = "_64-8";
export var featureSummary = "_64-a";
export var featureTitle = "_64-9";
export var modal = "_64-g";
export var modalAction = "_64-f";
export var modalCloseButton = "_64-e";
export var modalFeatures = "_64-5";
export var modalFooter = "_64-b";
export var modalImageLogo = "_64-c";
export var modalLogo = "_64-d";
export var redoModal = "_64-4";